import { useEffect } from "react";
import useHistory from "routing/useHistory";
import F5NetworksRoutes from "./common/Routes";
const F5NetworksInputConfiguration = ({ url = F5NetworksRoutes.INTEGRATIONS.F5Networks.ACTIVITYAPI.index }) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default F5NetworksInputConfiguration;
